export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13851.05533526.jpg";